import './Features.css'
import React from 'react'
import TitleSection from '../TitleSection/TitleSection'
import img1 from '../img/fet.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye, faChartLine, faTachometerAlt, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const FeatureItem = ({ item, delay }) => {
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <div className="col-lg-6">
      <motion.div
        ref={ref}
        className="single-feature-item"
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1, delay }}
      >
        <div className="feature-icon">
          {item.icon}
        </div>
        <div className="media-body">
          <h5>{item.title}</h5>
          <p>{item.des}</p>
        </div>
      </motion.div>
    </div>
  );
};

function Features() {
  const [refImg, inViewImg] = useInView({ triggerOnce: true });

  const datels = [
    {
      id: 1,
      title: 'شمولية المحتوى',
      des: 'تحتوي المواقع الإلكترونية على محتوى متنوع يغطي عدة جوانب من النشاط التجاري، مما يزيد من تفاعل الجمهور.',
      icon: <FontAwesomeIcon icon={faBullseye} />
    },
    {
      id: 2,
      title: 'تحقيق الأهداف ',
      des: 'تصميم المواقع الإلكترونية بشكل جيد يمكن أن يعزز من تحقيق الأهداف , بما في ذلك زيادة الزيارات والتحويلات.',
      icon: <FontAwesomeIcon icon={faChartLine} />
    },
    {
      id: 3,
      title: 'تحليل البيانات',
      des: 'يمكن تتبع أداء المواقع الإلكترونية بسهولة وتحليل البيانات لفهم سلوك الزوار وتحسين التجربة.',
      icon: <FontAwesomeIcon icon={faTachometerAlt} />
    },
    {
      id: 4,
      title: 'إمكانية التخصيص',
      des: 'يمكن تخصيص المواقع الإلكترونية لتلبية احتياجات جمهور محدد أو لتحقيق أهداف معينة .',
      icon: <FontAwesomeIcon icon={faSlidersH} />
    },
  ];
  

  return (
    <div className='features' id='featuresid'>
      <div className="container">
        <TitleSection title="مزايا " span='الموقع الإلكتروني' />
        <div className="row align-items-center">
          <div className="col-lg-5 text-center md-m-2">
            <motion.img
              ref={refImg}
              src={img1}
              alt="مزايا  الموقع الإلكتروني"
              className='img-fluid'
              initial={{ opacity: 0, y: -50 }}
              animate={inViewImg ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1 }}
            />
          </div>
          <div className="col-lg-7">
            <div className="row">
              {datels.map((item, index) => (
                <FeatureItem key={index} item={item} delay={index * 0.2} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features
